<wl-content-section [id]="id()" [theme]="theme()">
  @if (fields()) {
    <wl-text-widget
      [inverse]="inverse()"
      [title]="title()!"
      [content]="content()!"
      [widget]="rendering()"
    />
  }
</wl-content-section>
